import RiaSettings from '@client/models/store/settings/ria';
// eslint-disable-next-line import/no-cycle
import GoalSettings from '@client/models/store/settings/goal';
// eslint-disable-next-line import/no-cycle
import AccountSettings from '@client/models/store/settings/account';
import EnterpriseSettings from '@client/models/store/settings/enterprise';
import FooterSettings from '@client/models/store/settings/footer';

export default class Settings {
  constructor() {
    this.areRiaSettingsLoaded = false;
    this.isSegmentsSet = false;
    this.canAddAccount = null;
    this.canOverrideRisk = null;
    this.canTakeRiskQuestionnaire = null;
    this.canMoveMoney = null;
    this.cdo = null;
    this.showTotalCash = null;
    this.requiresBankLinkIdentityVerification = null;
    this.requiresBalanceCheck = null;
    this.accountMinimumAmount = 0;
    this.clientMinimumAmount = 0;
    this.showContactUs = false;
    this.bccOnLiquidationEmails = true;
    this.ria = new RiaSettings();
    this.goal = new GoalSettings();
    this.account = new AccountSettings();
    this.enterprise = new EnterpriseSettings();
    this.footer = new FooterSettings();
    this.linkAlias = null;
  }

  static binaryToBool(data) {
    // the `|| false` is technically unncecessary, but let's always return a bool just in case!
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    return (data && data.featureValue && data.featureValue !== '0') || false;
  }
}
